export default __webpack_public_path__ + "static/media/EngineeringTunnels_05.3fa69eb3.png";